var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.kit)?_c('fragment',[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column col-12"},[_c('kit-itens',{attrs:{"kit":_vm.kit}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"columns"},[_c('kit-totals',{attrs:{"kit":_vm.kit}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }